import { render, staticRenderFns } from "./BetslipHeader.vue?vue&type=template&id=9915663c&scoped=true"
import script from "./BetslipHeader.vue?vue&type=script&lang=js"
export * from "./BetslipHeader.vue?vue&type=script&lang=js"
import style0 from "./BetslipHeader.vue?vue&type=style&index=0&id=9915663c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9915663c",
  null
  
)

export default component.exports